import { render, staticRenderFns } from "./TaskHistoryRow.vue?vue&type=template&id=08e5a461&"
import script from "./TaskHistoryRow.vue?vue&type=script&lang=js&"
export * from "./TaskHistoryRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports